<template>
  <div class="reviews-list">
    <div
      v-for="{
        id,
        only_name,
        avatar,
        rating,
        message,
        photos,
        reply_text,
      } in items"
      :key="id"
      class="reviews-list__item"
      itemprop="review"
      itemscope=""
      itemtype="https://schema.org/Review"
    >
      <div
        class="reviews-list__author"
        itemprop="author"
        itemscope="itemscope"
        itemtype="http://schema.org/Person"
      >
        <div class="reviews-list__author-avatar u-flex-shrink-0">
          <avatar :name="only_name || 'Аnonymous'" :photo="avatar" />
        </div>
        <div
          class="reviews-list__author-name font-semibold"
          itemprop="only_name"
        >
          <meta itemprop="name" :content="only_name || 'Аnonymous'">
          {{ only_name || 'Аnonymous' }}
        </div>
        <button-icon tag="span" size="sm">
          <template #icon>
            <icon icon="star" />
          </template>
          <span class="u-text-green-dark">{{ getRating(rating) }}</span>
        </button-icon>
      </div>
      <div
        v-if="itemName"
        itemprop="itemReviewed"
        itemscope=""
        itemtype="https://schema.org/Organization"
      >
        <meta itemprop="name" :content="itemName" />
      </div>
      <div class="reviews-list__text">
        <extension-cropped
          :label-extended="$t('dropdownTrigger.more.extended')"
          :label-shrunk="$t('dropdownTrigger.more.shrunk')"
          :show-icon="false"
        >
          <div itemprop="reviewBody" v-html="message"></div>
        </extension-cropped>
      </div>
      <div v-if="photos.length" class="reviews-list__gallery">
        <gallery :gallery="photos" />
      </div>
      <reviews-reply :reviews="reviews" :expert-data="expertData" :reply_text="reply_text"/>
    </div>
  </div>
</template>

<script>
import getRating from "@/assets/js/utils/get-rating";
import Avatar from "@/components/ui-kit/avatar/index.vue";
import ButtonIcon from "@/components/ui-kit/button-icon/index.vue";
import Icon from "@/components/icons/index.vue";
import ExtensionCropped from "@/components/ui-kit/extension-cropped/index.vue";
import Gallery from "@/components/organisms/gallery/index.vue";
import ReviewsReply from "./reviews-reply.vue";

export default {
  components: {
    Avatar,
    ButtonIcon,
    Icon,
    ExtensionCropped,
    Gallery,
    ReviewsReply,
  },
  props: {
    reviews: {
      type: Array,
      required: true,
    },
    itemName: {
      type: String,
      default: "",
    },
    expertData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    items() {
      return this.reviews.map((review) => ({
        ...review,
        photos:
          (review.photos &&
            review.photos.length &&
            review.photos.map(({ AllocationSrc }, index) => ({
              id: index,
              path: AllocationSrc,
            }))) ||
          [],
      }));
    },
  },
  methods: {
    getRating,
  },
};
</script>

<style lang="scss" scoped>
.reviews-list {
  &__item {
    padding: 16px 0;
    border-top: 1px solid var.$gray-light;
  }

  &__author {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    &-avatar {
      width: 32px;
    }

    > * + * {
      margin-left: 8px;
    }
  }

  &__gallery {
    margin-top: 20px;
  }
}
</style>
